<template>
  <div class="update_registration_page">
    <div class="first_registration">
      <div class="regist_info">
        <h1>运动员注册页</h1>
        <div class="basic_information">
          <div class="info_left">
            <p>运动员基本信息</p>
          </div>
          <div class="info_right">
            <registrationForm
              :operation="updateObj.type"
              :formInfo="formInfo"
              ref="registrationForm"
              :uptoken="uptoken"
            ></registrationForm>
          </div>
        </div>
        <!-- 学籍信息 -->
        <div class="student_status">
          <div class="info_left">
            <p>学籍信息</p>
          </div>
          <div class="info_right">
            <studentStatus :operation="updateObj.type" :formInfo="formInfo" ref="studentStatus"></studentStatus>
          </div>
        </div>
        <!-- 注册组别 -->
        <div class="regist_group">
          <div class="info_left">
            <p>注册组别</p>
          </div>
          <div class="info_right">
            <registGroup :operation="updateObj.type" :formInfo="formInfo" ref="registGroup"></registGroup>
          </div>
        </div>
        <!-- 应急联系人 -->
        <div class="related_links">
          <div class="info_left">
            <p>相关联系</p>
          </div>
          <div class="info_right">
            <relatedLinks
              :operation="updateObj.type"
              :formInfo="formInfo"
              :coachList="coachList"
              ref="relatedLinks"
            ></relatedLinks>
          </div>
        </div>
        <!-- 证明材料,分会审核通过前显示 -->
        <div class="evidence">
          <div class="info_left">
            <p>证明材料</p>
          </div>
          <div class="info_right">
            <div class="card_box">
              <p>
                身份证照片
                <span>*</span>
              </p>
              <ul class="upload_card">
                <li>
                  <el-upload
                    v-if="updateObj.type != 'watch'"
                    :before-upload="$event=>handleBefore($event,'positive')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.frontImage"
                      v-if="imgList.frontImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.frontImage"
                      :loading="loadingData.positive"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>
                  <template v-else>
                    <template v-if="userInfo.type !== 4">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点击可查看大图"
                        placement="right-start"
                      >
                        <viewer
                          :images="[imgList.frontImage,imgList.backImage,imgList.studentImage,imgList.recruitImage]"
                        >
                          <img
                            :src="imgList.frontImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.backImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            v-show="false"
                            :src="imgList.studentImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.recruitImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                        </viewer>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <img
                        :src="imgList.frontImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px;"
                        alt
                      />
                    </template>
                  </template>
                  <p v-if="!imgList.frontImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">正面</p>
                </li>
                <li>
                  <el-upload
                    v-if="updateObj.type != 'watch'"
                    :before-upload="$event=>handleBefore($event,'back')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.backImage"
                      v-if="imgList.backImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.backImage"
                      :loading="loadingData.back"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>
                  <template v-else>
                    <template v-if="userInfo.type !== 4">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="点击可查看大图"
                        placement="right-start"
                      >
                        <viewer
                          :images="[imgList.frontImage,imgList.backImage,imgList.studentImage,imgList.recruitImage]"
                        >
                          <img
                            :src="imgList.frontImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.backImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            v-show="false"
                            :src="imgList.studentImage"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                          <img
                            :src="imgList.recruitImage"
                            v-show="false"
                            style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                            alt
                          />
                        </viewer>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <img
                        :src="imgList.backImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px;"
                        alt
                      />
                    </template>
                  </template>
                  <p v-if="!imgList.backImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">反面</p>
                </li>
              </ul>
            </div>
            <div class="graduation_box">
              <div>
                <p>
                  学生证照片
                  <span>*</span>
                </p>
                <ul class="upload_card">
                  <li>
                    <el-upload
                      v-if="updateObj.type != 'watch'"
                      :before-upload="$event=>handleBefore($event,'studentImage')"
                      :on-success="uploadSuccess"
                      :show-file-list="false"
                      :data="{token: uptoken}"
                      accept="image/jpeg, image/jpg, image/png"
                      action="//up-z1.qiniup.com"
                    >
                      <img
                        :src="imgList.studentImage"
                        v-if="imgList.studentImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px"
                        alt
                      />
                      <el-button
                        v-if="!imgList.studentImage"
                        :loading="loadingData.positive"
                        type="primary"
                        icon="el-icon-upload"
                      >选择上传文件</el-button>
                    </el-upload>
                    <template v-else>
                      <template v-if="userInfo.type !== 4">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="点击可查看大图"
                          placement="right-start"
                        >
                          <viewer
                            :images="[imgList.frontImage,imgList.backImage,imgList.studentImage,imgList.recruitImage]"
                          >
                            <img
                              :src="imgList.frontImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.backImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.studentImage"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.recruitImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                          </viewer>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <img
                          :src="imgList.studentImage"
                          style="width:85.6mm;height:54mm;margin-bottom:10px;"
                          alt
                        />
                      </template>
                    </template>
                    <p v-if="!imgList.studentImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  </li>
                </ul>
              </div>
              <div>
                <p>
                  招生录取大表
                  <span>*</span>
                </p>
                <ul class="upload_card">
                  <li>
                    <el-upload
                      v-if="updateObj.type != 'watch'"
                      :before-upload="$event=>handleBefore($event,'studentLastImg')"
                      :on-success="uploadSuccess"
                      :show-file-list="false"
                      :data="{token: uptoken}"
                      accept="image/jpeg, image/jpg, image/png"
                      action="//up-z1.qiniup.com"
                    >
                      <img
                        :src="imgList.recruitImage"
                        v-if="imgList.recruitImage"
                        style="width:85.6mm;height:54mm;margin-bottom:10px"
                        alt
                      />
                      <el-button
                        v-if="!imgList.recruitImage"
                        :loading="loadingData.back"
                        type="primary"
                        icon="el-icon-upload"
                      >选择上传文件</el-button>
                    </el-upload>
                    <template v-else>
                      <template v-if="userInfo.type !== 4">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="点击可查看大图"
                          placement="right-start"
                        >
                          <viewer
                            :images="[imgList.frontImage,imgList.backImage,imgList.studentImage,imgList.recruitImage]"
                          >
                            <img
                              :src="imgList.frontImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.backImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                            <img
                              :src="imgList.studentImage"
                              v-show="false"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;"
                              alt
                            />
                            <img
                              :src="imgList.recruitImage"
                              style="width:85.6mm;height:54mm;margin-bottom:10px;cursor:pointer"
                              alt
                            />
                          </viewer>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <img
                          :src="imgList.recruitImage"
                          style="width:85.6mm;height:54mm;margin-bottom:10px;"
                          alt
                        />
                      </template>
                    </template>
                    <p v-if="!imgList.recruitImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remark">
          <div class="info_left">
            <p>备注</p>
          </div>
          <div
            class="info_right"
            :style="{padding:updateObj.type === 'watch'?(imgList.remarksImage.length === 0?'30px 25px':'20px 25px'):'20px 25px'}"
          >
            <template v-if="updateObj.type === 'watch'">
              <p
                :style="{marginBottom:imgList.remarksImage.length === 0 ?'0':'20px'}"
              >{{!formInfo.remarks?'无':formInfo.remarks}}</p>
              <viewer :images="imgList.remarksImage">
                <img
                  style="width:100px;height:100px;margin-right:20px;cursor:pointer"
                  v-for="(item,index) in imgList.remarksImage"
                  :src="item"
                  :key="index"
                  alt
                />
              </viewer>
            </template>
            <template v-else>
              <el-input
                type="textarea"
                class="remark_input"
                v-model="query.remarks"
                :autosize="{minRows:2,maxRows:5}"
                resize="none"
                placeholder="输入内容"
              ></el-input>
              <div class="upload_img">
                <el-upload
                  action="//up-z1.qiniup.com"
                  multiple
                  :before-upload="handleBeforeMultipie"
                  :on-success="uploadSuccessMultipie"
                  :show-file-list="false"
                  :file-list="remarksFileList"
                  :limit="9"
                  :on-exceed="handleExceed"
                  :data="{token: uptoken}"
                  accept="image/jpeg, image/jpg, image/png"
                >
                  <el-button>添加附件</el-button>
                </el-upload>
                <div style="display:flex;flex-wrap:wrap">
                  <viewer class="rows" :images="imgList.remarksImage">
                    <section v-for="(item,index) in imgList.remarksImage" :key="item">
                      <img class="up_img" :src="item" alt />
                      <span class="close_btn" @click="deleteRemarkImage(index)">×</span>
                    </section>
                  </viewer>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 审核意见，只有最后审核完成后才显示 -->
        <div
          class="examine_result"
          v-if="(userInfo.type == 1 || userInfo.type === 3 || userInfo.type === 5) && formInfo.state === 5"
        >
          <div class="info_left">
            <p>审核意见</p>
          </div>
          <div class="info_right">
            <section>
              <p class="first">学校意见：</p>
              <p class="next">通过</p>
              <p class="last">{{formInfo.schoolAuditTime?formInfo.schoolAuditTime.split(' ')[0]:''}}</p>
            </section>
            <section>
              <p class="first">省学校体协意见：</p>
              <p class="next">通过</p>
              <p class="last">{{formInfo.societyAuditTime?formInfo.societyAuditTime:''}}</p>
            </section>
          </div>
        </div>
        <div
          class="notice"
          v-if="(userInfo.type === 2 && formInfo.state === 1) || ((userInfo.type === 3 || userInfo.type === 1 || userInfo.type === 5) && formInfo.state === 3) || (userInfo.type === 4 && updateObj.type !== 'watch')"
        >
          <div class="notice_left">
            <p>须知</p>
          </div>
          <div v-if="showStep" class="notice_right">
            <el-checkbox v-model="checked">本人已知晓浙江省教育厅关于运动员资格的相关规定，承诺所填内容真实。</el-checkbox>
          </div>
          <template v-else>
            <!-- 学校审核员 -->
            <div v-if="userInfo.type === 2" style="padding:10px;border-left:1px solid #979797;">
              <p>本人已知晓浙江省教育厅关于运动员资格的相关规定，承诺所填内容真实。</p>
              <p style="margin:10px 0;color:#409EFF">运动员提交时间：{{formInfo.createDate}}</p>
              <el-checkbox v-model="examine">本人已对该运动员相关注册内容进行审核，内容真实。</el-checkbox>
            </div>
            <!-- 分会审核员及学校管理员 -->
            <div
              v-if="userInfo.type === 3 || userInfo.type === 1 || userInfo.type === 5"
              style="padding:10px;border-left:1px solid #979797;"
            >
              <p>本人已知晓浙江省教育厅关于运动员资格的相关规定，承诺所填内容真实。</p>
              <p style="margin:10px 0;color:#409EFF">运动员提交时间：{{formInfo.createDate}}</p>
              <p>学校审核意见：已对该运动员相关注册内容进行审核，内容真实。</p>
              <section style="margin:10px 0;display:flex;align-items:center">
                <p style="color:#409EFF">学校审核时间：{{formInfo.schoolAuditTime}}</p>
                <p style="margin-left:40px;color:#222;">
                  状态：
                  <span
                    :style="{color:formInfo.state === 3?'rgb(51, 204, 154)':'rgb(252, 91, 91)'}"
                  >{{formInfo.state == 3?'通过':'驳回'}}</span>
                </p>
              </section>
            </div>
          </template>
        </div>
        <!-- 驳回理由 -->
        <div class="reject_reason" v-if="formInfo.state === 2 || formInfo.state === 4">
          <div class="info_left">
            <p>驳回理由</p>
          </div>
          <div class="info_right">{{!formInfo.reason?'无':formInfo.reason}}</div>
        </div>
      </div>
    </div>
    <div class="btn_box" v-if="updateObj.type !== 'watch'">
      <el-button
        style="width:90px"
        class="save_btn"
        :disabled="!checked"
        :loading="saveLoading"
        @click="submits(0)"
      >保存</el-button>
      <el-button
        :disabled="!checked"
        style="width:90px;margin:0 40px"
        class="normal_btn"
        :loading="btnLoading"
        @click="submits(1)"
      >提交</el-button>
      <el-button style="width:90px" v-if="false" class="normal_btn">打印</el-button>
    </div>
    <div v-else class="show_steps">
      <template v-if="showStep">
        <ul class="steps">
          <li class="submits" :style="{color:formInfo.state === 0?'#333':'#1E63B0'}">
            <span
              v-if="formInfo.state === 0"
              class="circle"
              :class="formInfo.state === 0?'in_there':''"
            >1</span>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            {{formInfo.state === 0?'待提交':'已提交'}}
            <span
              class="line"
              :style="{background:formInfo.state > 0?'#1E63B0':'#979797'}"
            ></span>
          </li>
          <li
            class="steps_second"
            :style="{color:formInfo.state === 0?'#979797':formInfo.state === 1?'':formInfo.state === 2?'#f56c6c':'#1E63B0'}"
          >
            <span
              v-if="formInfo.state <= 1 "
              class="circle"
              :class="formInfo.state === 1?'in_there':'normal_color'"
            >2</span>
            <i
              v-else-if="formInfo.state === 2"
              class="el-icon-circle-close"
              style="font-size:24px;margin-right:6px"
            ></i>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            {{formInfo.state === 0?'校内待审核':formInfo.state === 1?'校内审核中':formInfo.state === 2?'校内审核驳回':'校内审核通过'}}
            <span
              class="line"
              :style="{background:formInfo.state >= 3?'#1E63B0':'#979797'}"
            ></span>
          </li>
          <li
            class="steps_next"
            :style="{color:formInfo.state < 3?'#999':formInfo.state === 3?'':formInfo.state === 4?'#f56c6c':'#1E63B0'}"
          >
            <span
              v-if="formInfo.state <= 3"
              :class="formInfo.state < 3?'normal_color':'in_there'"
              class="circle"
            >3</span>
            <i
              v-else-if="formInfo.state === 4"
              class="el-icon-circle-close"
              style="font-size:24px;margin-right:6px"
            ></i>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            {{formInfo.state < 3?'协会待审核':formInfo.state === 3?'协会审核中':formInfo.state === 4?'协会审核驳回':'协会审核通过'}}
            <span
              class="line"
              :style="{background:formInfo.state >= 5?'#1E63B0':'#979797'}"
            ></span>
          </li>
          <li class="steps_last" :style="{color:formInfo.state < 5?'#999':'#1E63B0'}">
            <span
              v-if="formInfo.state < 5"
              class="circle"
              :class="formInfo.state < 5?'normal_color':'in_there'"
            >4</span>
            <i v-else class="el-icon-circle-check" style="font-size:24px;margin-right:6px"></i>
            完成
          </li>
        </ul>
      </template>
      <!-- userInfo.type === 4 -->
      <el-button style="width:90px" class="normal_btn" @click="print">打印</el-button>
    </div>
    <div class="btn_box" style="margin-top:20px;" v-if="!showStep">
      <el-button
        :disabled="!examine && userInfo.type === 2"
        style="width:100px;margin-right:40px;padding:12px 0;text-align:center"
        type="primary"
        :loading="loadingData.passLoading"
        @click="passAndSubmit"
      >通过并提交</el-button>
      <el-button
        style="width:100px"
        type="danger"
        @click="rejects"
        :loading="loadingData.rejectLoading"
      >驳回</el-button>
    </div>
    <athleteRegistrationPrint
      :coachList="coachList"
      ref="athleteRegistrationPrint"
      :formInfo="formInfo"
    ></athleteRegistrationPrint>
    <el-dialog
      width="700px"
      title="驳回理由"
      :visible.sync="rejectVisible"
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeRejectDialog"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="reason"
        resize="none"
        height="450px"
        maxlength="200"
        show-word-limit
        :autosize="{ minRows: 8, maxRows: 15}"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submitLoading"
          style="width:90px;margin-right:40px"
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import athleteRegistrationPrint from "@/components/athlete-registration-print.vue";
import relatedLinks from "./related-links";
import studentStatus from "./student-status";
import registGroup from "./regist-group";
import registrationForm from "./registration_form";
import { getUploadToken } from "@/api/upload.js";
import { coachSocietyAudit } from "@/api/coach.js";
import { method } from "@/utils/utils";
import { getSession } from "@/utils/storage.js";
import { message, btn } from "@/common/js/mixins.js";
import {
  getCoachList,
  updateAthletes,
  getAthletesDetails,
  getAthleteList,
  societyAudit,
  schoolAudit
} from "@/api/athletes.js";
export default {
  mixins: [message, btn],
  components: {
    registrationForm,
    relatedLinks,
    studentStatus,
    registGroup,
    athleteRegistrationPrint
  },
  props: {
    updateObj: {
      type: Object
    }
  },
  data() {
    return {
      rejectVisible: false,
      submitLoading: false,
      fileList: [],
      remarksFileList: [],
      examine: false,
      userInfo: JSON.parse(getSession("userInfo")) || null,
      saveLoading: false,
      checked: false,
      uptoken: "",
      uploadType: "",
      files: "",
      reason: "",
      imgList: {
        frontImage: "", //身份证正面(图片)
        backImage: "", //身份证背面(图片)
        studentImage: "", // 学生证照片第一面
        recruitImage: "", //学生证照片第二面
        remarksImage: []
      },
      reason: "",
      coachList: [],
      query: {
        frontImage: "", //身份证正面
        backImage: "", //身份证背面
        studentImage: "",
        recruitImage: "",
        remarks: "",
        remarksImage: [],
        id: this.updateObj.id
      },
      loadingData: {
        positive: false,
        back: false,
        studentFirst: false,
        studentLast: false,
        passLoading: false,
        rejectLoading: false
      },
      // 详情数据
      formInfo: {
        state: ""
      }
    };
  },
  computed: {
    showStep() {
      let type = this.userInfo ? this.userInfo.type : null;
      let { state } = this.formInfo;
      switch (type) {
        // 学校管理员
        case 1: {
          if (state === 3) return false;
          else return true;
        }
        // 学校审核员
        case 2: {
          if (state === 1) return false;
          else return true;
        }
        // 分会审核会
        case 3: {
          if (state === 3) return false;
          else return true;
        }
        // 学校注册员
        case 4: {
          return true;
        }
        default: {
          if (state === 3) return false;
          else return true;
        }
      }
    }
  },
  methods: {
    // 打印
    print() {
      this.isShowBottom = false;
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#athleteRegistrationPrint"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 10mm;} .first_registration {margin-top:15mm} .info_left {width: 104px;border-right: 1px solid #979797;display: flex;align-items: center;justify-content: center;} .info_left>p {line-height: 24px;width: 24px;font-size: 20px;text-align: center;} .student_status,.regist_group,.related_links,.examine_result,.remark,.reject_reason {display: flex;border-top: 1px solid #979797} .left_info li{margin-bottom:15px} div,ul,li,p,span,section{padding:0;margin:0} .rows {display:flex;align-items:center} .row_title {width:115px;text-align:right}</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    },
    show(index) {
      const viewer = this.$el.querySelectorAll(".rows")[index].$viewer;
      viewer.show();
    },
    // 超出上传限制个数
    handleExceed(files, fileList) {
      this.openWarn("最多只能上传9张图片！");
    },
    // 删除附件图片
    deleteRemarkImage(index) {
      this.remarksFileList.splice(index, 1);
      this.imgList.remarksImage.splice(index, 1);
      this.query.remarksImage.splice(index, 1);
    },
    // 附件上传前判断size及文件格式
    handleBeforeMultipie(file) {
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过5MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        return false;
      }
      this.fileList.push(file);
      return testmsg && isLt5M;
    },
    // 附件上传成功
    uploadSuccessMultipie(data, file, fileList) {
      this.remarksFileList = fileList;
      this.query.remarksImage.push(data.key);
      this.imgList.remarksImage.push(window.URL.createObjectURL(file.raw));
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name === file.name) {
          this.fileList.splice(i, 1);
          i--;
        }
      }
    },
    // 驳回弹窗关闭
    closeRejectDialog() {
      this.reason = "";
    },
    // 驳回提交
    handleSubmit() {
      this.loadingData.rejectLoading = true;
      // 学校审核员驳回
      if (this.userInfo.type === 2) {
        schoolAudit({
          ids: this.formInfo.id,
          reason: this.reason,
          state: 2
        })
          .then(res => {
            this.openSuccess("提交成功!");
            this.$emit("examineSubmit");
            this.rejectVisible = false;
            this.loadingData.rejectLoading = false;
          })
          .catch(err => {
            this.rejectVisible = false;
            this.loadingData.rejectLoading = false;
          });
      } else {
        societyAudit({
          ids: this.formInfo.id,
          reason: this.reason,
          state: 4
        })
          .then(res => {
            this.openSuccess("提交成功!");
            this.$emit("examineSubmit");
            this.rejectVisible = false;
            this.loadingData.rejectLoading = false;
          })
          .catch(err => {
            this.rejectVisible = false;
            this.loadingData.rejectLoading = false;
          });
      }
    },
    // 驳回弹窗关闭
    handleCancel() {
      this.rejectVisible = false;
    },
    // 通过并提交
    passAndSubmit() {
      this.loadingData.passLoading = true;
      // 学校审核员通过
      if (this.userInfo.type === 2) {
        schoolAudit({
          ids: this.formInfo.id,
          state: 3
        })
          .then(res => {
            this.openSuccess("提交成功!");
            this.$emit("examineSubmit");
            this.loadingData.passLoading = false;
          })
          .catch(err => {
            this.loadingData.passLoading = false;
          });
      } else {
        societyAudit({
          ids: this.formInfo.id,
          state: 5
        })
          .then(res => {
            this.openSuccess("提交成功!");
            this.$emit("examineSubmit");
            this.loadingData.passLoading = false;
          })
          .catch(err => {
            this.loadingData.passLoading = false;
          });
      }
    },
    // 驳回
    rejects() {
      this.rejectVisible = true;
    },
    // 返回上级
    backs() {
      this.$emit("clearUpdate");
    },
    // 点击提交按钮
    submits(type) {
      let obj = {};
      // 调用子组件表单验证
      this.$refs.registrationForm.submits().then(res => {
        if (!res) return;
        obj = Object.assign(obj, res);
        this.$refs.studentStatus.submits().then(res => {
          if (!res) return;
          obj = Object.assign(obj, res);
          this.$refs.registGroup.submits().then(res => {
            if (!res) return;
            obj = Object.assign(obj, res);
            this.$refs.relatedLinks.submits().then(res => {
              if (!res) return;
              obj = Object.assign(obj, res);
              let {
                frontImage,
                backImage,
                studentImage,
                recruitImage,
                id,
                remarks,
                remarksImage
              } = this.query;
              let { headImage } = obj;
              // 修改时，图片路径只截取最后一个/后的内容
              frontImage = frontImage.split("/")[
                frontImage.split("/").length - 1
              ];
              backImage = backImage.split("/")[backImage.split("/").length - 1];
              studentImage = studentImage.split("/")[
                studentImage.split("/").length - 1
              ];
              recruitImage = recruitImage.split("/")[
                recruitImage.split("/").length - 1
              ];
              headImage = headImage.split("/")[headImage.split("/").length - 1];
              let arr = [];
              remarksImage.filter(item => {
                if (item.split("/").length > 1) {
                  arr.push(item.split("/")[item.split("/").length - 1]);
                } else {
                  arr.push(item.split("/")[0]);
                }
              });
              if (type === 0) this.saveLoading = true;
              else this.openBtn();
              updateAthletes({
                ...obj,
                frontImage,
                backImage,
                studentImage,
                headImage,
                recruitImage,
                remarks,
                remarksImage: arr.join(","),
                id,
                state: type
              })
                .then(res => {
                  if (type === 0) this.saveLoading = false;
                  else this.closeBtn();
                  this.$message({
                    type: "success",
                    message: type === 0 ? "保存成功!" : "修改成功!"
                  });
                  this.backs();
                })
                .catch(err => {
                  if (type === 0) this.saveLoading = false;
                  else this.closeBtn();
                });
            });
          });
        });
      });
    },
    // 上传前判断size及文件格式
    handleBefore(file, type) {
      this.uploadType = type;
      this.files = file;
      if (type === "positive") this.loadingData.positive = true;
      else if (type === "back") this.loadingData.back = true;
      else if (type === "studentImage") this.loadingData.studentFirst = true;
      else this.loadingData.studentLast = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过2MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          studentFirst: false,
          studentLast: false
        });
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          studentFirst: false,
          studentLast: false
        });
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.$message.success("上传成功！");
      if (this.uploadType === "positive") {
        this.query.frontImage = response.key;
        this.imgList.frontImage = window.URL.createObjectURL(this.files);
        this.loadingData.positive = false;
      } else if (this.uploadType === "back") {
        this.query.backImage = response.key;
        this.imgList.backImage = window.URL.createObjectURL(this.files);
        this.loadingData.back = false;
      } else if (this.uploadType === "studentImage") {
        this.loadingData.studentFirst = false;
        this.query.studentImage = response.key;
        this.imgList.studentImage = window.URL.createObjectURL(this.files);
      } else {
        this.loadingData.studentLast = false;
        this.query.recruitImage = response.key;
        this.imgList.recruitImage = window.URL.createObjectURL(this.files);
      }
    },
    // 获取token
    getToken() {
      getUploadToken({
        type: 1
      })
        .then(res => {
          this.uptoken = res;
        })
        .catch(err => {});
    },
    // 获取注册信息教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = res;
        })
        .catch(err => {});
    },
    // 清空表单
    resetForm() {
      this.$refs.registrationForm.resetForm();
    },
    // 获取详情
    isDetail(id, type) {
      getAthletesDetails({ id })
        .then(res => {
          this.checked = true;
          if (res.birthday) {
            res.birthday = method.timeFormat(res.birthday);
          }
          if (res.startSchoolDate) {
            res.startSchoolDate = method.timeFormat(res.startSchoolDate);
          }
          if (res.createDate) {
            res.createDate = method.timeFormat(res.createDate, null, 6);
          }
          if (res.schoolAuditTime) {
            res.schoolAuditTime = method.timeFormat(res.createDate, null, 6);
          }
          if (res.societyAuditTime) {
            res.societyAuditTime = method.timeFormat(res.societyAuditTime);
          }
          this.remarksFileList = [];
          for (let item in res) {
            if (this.query.hasOwnProperty(item)) {
              if (item === "remarksImage") {
                if (res[item]) {
                  let remarksImg = res[item].split(",");
                  let arr = [];
                  remarksImg.filter((temp, index) => {
                    arr.push("https://matchvideo.328ym.com/" + temp);
                    this.remarksFileList.push({
                      name: "img" + index,
                      url: temp
                    });
                  });
                  this.$set(this.query, item, [...arr]);
                  this.$set(this.imgList, item, [...arr]);
                } else {
                  this.$set(this.query, "remarksImage", []);
                  this.$set(this.imgList, "remarksImage", []);
                }
              } else {
                this.$set(this.query, item, res[item]);
                this.$set(this.imgList, item, res[item]);
              }
            }
          }

          this.formInfo = res;
        })
        .catch(err => {});
    }
  },
  watch: {
    updateObj: {
      deep: true,
      handler(value) {
        if (value.id) {
          this.isDetail(value.id, value.type);
        }
      }
    }
  },
  mounted() {
    this.getToken();
    this.getCoachLists();
    this.isDetail(this.updateObj.id, this.updateObj.type);
  }
};
</script>
<style lang="less" scoped>
@borders: 1px solid #979797;
.first_registration {
  border: @borders;
  min-width: 100px;
  margin: 0 50px;
  .regist_info {
    width: 100%;
    min-width: 900px;
    > h1 {
      line-height: 64px;
      text-align: center;
      font-size: 24px;
      color: #222;
    }
    > .basic_information {
      border-top: @borders;
      display: flex;
      min-width: 900px;

      .info_right {
        flex: 1;
      }
    }
  }
  .student_status,
  .regist_group,
  .related_links,
  .examine_result {
    display: flex;
    border-top: @borders;
    .info_right {
      flex: 1;
      padding: 40px 0 20px;
    }
  }
  .examine_result {
    .info_right {
      display: flex;
      padding: 0;
      > section {
        height: 150px;
        width: 50%;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .first {
          font-size: 16px;
        }
        .next {
          font-size: 24px;
          text-align: center;
        }
        .last {
          font-size: 16px;
          text-align: right;
        }

        &:first-of-type {
          border-right: 1px solid #979797;
        }
      }
    }
  }
  .evidence {
    border-top: @borders;
    display: flex;
    .info_right {
      padding: 20px 25px;
      flex: 1;
      p {
        display: flex;
        span {
          color: #fd6666;
        }
      }
      .upload_card {
        margin: 20px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        li {
          width: 48%;
          height: 300px;
          background: #e6e6e6;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .upload_format {
            font-size: 14px;
            margin: 20px 0;
          }
          .upload_tip {
            font-size: 18px;
          }
        }
      }
    }
  }
  .remark {
    border-top: @borders;
    display: flex;
    align-items: center;
    .info_left {
      width: 103px;
      // padding: 20px 0;
      border-right: none;
    }
    .info_right {
      border-left: @borders;
      flex: 1;
      .upload_img {
        display: flex;
      }
      .rows {
        display: flex;
        flex-wrap: wrap;
        > section {
          width: 100px;
          height: 100px;
          position: relative;
          margin: 0 0 20px 20px;
          > .up_img {
            cursor: pointer;
            border: 1px solid rgba(0, 0, 0, 0.2);
            width: 100%;
            height: 100%;
          }
          > .close_btn {
            cursor: pointer;
            position: absolute;
            top: -6px;
            right: -6px;
            width: 14px;
            height: 14px;
            line-height: 12px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            background: #1e63b0;
            border-radius: 50%;
          }
        }
      }
      /deep/ .remark_input .el-textarea__inner {
        border: none;
      }
    }
  }
  .notice {
    border-top: @borders;
    display: flex;
    align-items: center;
    .notice_left {
      width: 103px;
      text-align: center;
    }
    .notice_right {
      padding: 20px 0;
      border-left: @borders;
      padding-left: 25px;
    }
  }
  .info_left {
    width: 104px;
    border-right: @borders;
    display: flex;
    align-items: center;
    justify-content: center;
    > p {
      line-height: 24px;
      width: 24px;
      font-size: 20px;
      text-align: center;
    }
  }
  .reject_reason {
    border-top: @borders;
    display: flex;
    .info_left {
      width: 104px;
      font-size: 24px;
      border-right: @borders;
      padding: 20px;
    }
    .info_right {
      padding: 20px 25px;
      line-height: 20px;
      flex: 1;
    }
  }
}
.graduation_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div {
    width: 48%;
    li {
      width: 100% !important;
    }
  }
}
.show_steps {
  display: flex;
  margin: 24px 50px 0;
  align-items: center;
  .steps {
    display: flex;
    align-items: center;
    flex: 1;
    > li {
      display: flex;
      align-items: center;
      &.submits {
        color: #1e63b0;
        .line {
          background: #1e63b0;
        }
      }
      .line {
        width: 104px;
        height: 1px;
        margin: 0 10px;
      }
    }
    > .submits,
    .steps_second,
    .steps_next,
    .steps_last {
      .circle {
        width: 24px;
        font-size: 14px;
        border-radius: 50%;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        margin-right: 6px;
      }
    }
    .in_there {
      background: #1e63b0;
    }
    .normal_color {
      background: transparent;
      border: 1px solid #999;
      color: #999 !important;
    }
  }
}
.update_registration_page {
  position: relative;
  .backs {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.btn_box {
  margin: 40px 104px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.save_btn {
  background: #1e63b0;
  color: #fff;
}
.normal_btn {
  background: #fff;
  color: #1e63b0;
  border: 1px solid #1e63b0;
}
.disable_btn {
  background-color: #fff;
  border-color: #ebeef5;
  color: #c0c4cc;
}
</style>